var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 36,
    viewBox: "0 0 136 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.472 0.0478516H0V35.9519H11.472V31.5359H4.512V18.4799H10.128V14.1119H4.512V4.41585H11.472V0.0478516Z",
    fill: "#212020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6995 35.9519V0.0478516H15.1875V35.9519H19.6995Z",
    fill: "#212020"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9632 3.64785C35.9632 1.63185 34.4272 0.0478516 32.3633 0.0478516H26.9872C24.9712 0.0478516 23.3873 1.63185 23.3873 3.64785V9.26385C23.3873 12.7199 24.5393 14.4479 25.3073 15.5999L30.5393 23.8079C31.3073 24.9599 31.4993 25.7279 31.4993 26.6879V30.5759C31.4993 31.1519 31.0673 31.5359 30.4913 31.5359H28.9073C28.2833 31.5359 27.8993 31.1519 27.8993 30.5759V26.7359H23.3873V32.3519C23.3873 34.3679 24.9712 35.9519 26.9872 35.9519H32.3633C34.4272 35.9519 35.9632 34.3679 35.9632 32.3519V26.6879C35.9632 24.4799 35.2913 22.9439 34.4273 21.5999L29.5312 13.8719C28.3792 12.0959 27.8993 11.3279 27.8993 9.26385V5.42385C27.8993 4.84785 28.2833 4.41585 28.9073 4.41585H30.4913C31.0673 4.41585 31.4993 4.84785 31.4993 5.42385V9.26385H35.9632V3.64785Z",
    fill: "#212020"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1283 0.0478516H39.6562V35.9519H51.1283V31.5359H44.1683V18.4799H49.7842V14.1119H44.1683V4.41585H51.1283V0.0478516Z",
    fill: "#212020"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9638 20.3519L59.3558 0.0478516H54.8438V35.9519H59.3558V16.0319L63.9638 35.9519H68.4758V0.0478516H63.9638V20.3519Z",
    fill: "#212020"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9041 3.64785C84.9041 1.63185 83.3201 0.0478516 81.3041 0.0478516H72.3281V35.9519H81.3041C83.3201 35.9519 84.9041 34.3679 84.9041 32.3519V19.6799C84.9041 17.8559 83.7041 16.5599 82.1201 16.2239C83.7041 15.9359 84.9041 14.6399 84.9041 12.7679V3.64785ZM80.4401 13.1039C80.4401 13.6799 80.0081 14.1119 79.4321 14.1119H76.8401V4.41585H79.4321C80.0081 4.41585 80.4401 4.84785 80.4401 5.42385V13.1039ZM80.4401 30.5759C80.4401 31.1039 80.0081 31.5359 79.4321 31.5359H76.8401V18.4799H79.4321C80.0081 18.4799 80.4401 18.9119 80.4401 19.4879V30.5759Z",
    fill: "#212020"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.713 35.9519L97.4325 0.0478516H92.8725L87.6405 35.9519H92.2965L92.8245 31.2479H97.4805L98.0085 35.9519H102.713ZM95.1765 11.1359L96.9525 26.9279H93.3525L95.1765 11.1359Z",
    fill: "#212020"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M114.003 14.0639H110.403V0.0478516H105.891V35.9519H110.403V18.4319H114.003V35.9519H118.467V0.0478516H114.003V14.0639Z",
    fill: "#212020"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M131.417 20.3519L126.809 0.0478516H122.297V35.9519H126.809V16.0319L131.417 35.9519H135.929V0.0478516H131.417V20.3519Z",
    fill: "#212020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEise);
export default __webpack_public_path__ + "static/media/eise.7edd2b329665bad5b3eaaba4d81e6775.svg";
export { ForwardRef as ReactComponent };